import Vue from 'vue';
import {
  APPLY_OVERRIDE,
  CLEAR_OVERRIDE,
  SET_USER_CONVERSATION_MENU,
} from './types';

const EMPTY_OVERRIDES = {
  secondarySidebar: null,
  conversationMenu: null,
  contactPanel: null,
};

export const mutations = {
  // Single-source by design: only 'audit-drawer' uses this today. A second active
  // source would silently clobber the first — warn to surface it if multi-source
  // is ever added (at which point this becomes a source-keyed map).
  [APPLY_OVERRIDE]($state, { source, partial }) {
    if ($state.source && $state.source !== source) {
      // eslint-disable-next-line no-console
      console.warn(
        `[layoutOverrides] source "${source}" overrides active "${$state.source}" — single-source assumed`
      );
    }
    Vue.set($state, 'source', source);
    Vue.set($state, 'overrides', { ...$state.overrides, ...partial });
  },

  // Source-guarded: only the source that applied may clear. Redundant while
  // single-source (see APPLY_OVERRIDE), but kept so a future 2nd source can't
  // clear another source's override.
  [CLEAR_OVERRIDE]($state, { source }) {
    if ($state.source !== source) return;
    Vue.set($state, 'overrides', { ...EMPTY_OVERRIDES });
    Vue.set($state, 'source', null);
  },

  // Outside overrides on purpose — clears must not wipe the user's own collapse choice.
  [SET_USER_CONVERSATION_MENU]($state, value) {
    Vue.set($state, 'userConversationMenu', value);
  },
};
